var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from "react";
import { PeekInputSelect } from "@piiqtechnologies/ui-components";
const TIMEZONES = [
    "America/New_York",
    "America/Chicago",
    "America/Anchorage",
    "America/Phoenix",
    "America/Denver",
    "Pacific/Honolulu",
    "America/Los_Angeles",
    "America/Toronto",
    "America/St_Johns",
    "America/Halifax",
    "America/Winnipeg",
    "America/Regina",
    "America/Vancouver",
];
const TimezoneSelector = (_a) => {
    var { field } = _a, props = __rest(_a, ["field"]);
    const selectItems = useMemo(() => TIMEZONES === null || TIMEZONES === void 0 ? void 0 : TIMEZONES.map((timezone) => ({ id: timezone, name: timezone })), []);
    return React.createElement(PeekInputSelect, Object.assign({ labelProps: { sx: { fontWeight: "normal" } } }, props, { field: field, items: selectItems }));
};
export default TimezoneSelector;
